import React from 'react';
type FrameProps = {
  children: React.ReactNode;
  className?: string;
};
export function Frame({
  children,
  className = ''
}: FrameProps) {
  return <div className="px-4 md:px-6" data-id="element-232" data-mp="3jtkq7lopc0vb">
      <div className="relative mx-auto max-w-[1360px]" data-id="element-233" data-mp="3ou8e3yhmw1lb">
        <span className="rail-ticks pointer-events-none absolute inset-y-0 -left-[9px] hidden w-[9px] md:block" aria-hidden="true" data-id="element-234" data-mp="3otfc1atme09i" />
        <span className="rail-ticks rail-ticks--right pointer-events-none absolute inset-y-0 -right-[9px] hidden w-[9px] md:block" aria-hidden="true" data-id="element-235" data-mp="2ffjh5xf1tmc" />
        <div className={`relative border-x border-rail ${className}`} data-id="element-236" data-mp="6f6750rnbtmn">{children}</div>
      </div>
    </div>;
}